import { StyleSheet } from 'react-native';
import React from 'react';
import { Box, Switch, SwitchProps, SxProps, Theme, Typography } from '@mui/material';
import { ColorScheme, theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { CustomizedSwitches } from './Switch';

export interface ISwitchWithCustomText {
    header: string;
    body: string;
    theme: ColorScheme;
    style?: React.CSSProperties;
    sx?: SxProps<Theme>;
    switchProps?: SwitchProps;
    switchType?: 'ios' | 'android';
    textStyle?: React.CSSProperties;
    subtitleStyle?: React.CSSProperties;
}

const SwitchWithCustomText: React.FC<ISwitchWithCustomText> = props => {
    const { body, header, theme, style, sx, switchProps, switchType, textStyle, subtitleStyle } = props;
    const styles = dynamicStyles(theme);
    const mergedStyles = { ...styles.flexRow, ...style };
    return (
        <Box style={mergedStyles} sx={{ gap: '18px', ...sx }}>
            {switchType === 'ios' ? <CustomizedSwitches switchProps={switchProps} /> : <Switch {...switchProps} />}
            <Box style={styles.flexColumn} sx={{ gap: '4px' }}>
                <Typography style={{ ...styles.subtitle, ...subtitleStyle }}>{header}</Typography>
                <Typography style={{ ...styles.text, ...textStyle }}>{body}</Typography>
            </Box>
        </Box>
    );
};

const dynamicStyles = (colorScheme: ColorScheme) =>
    StyleSheet.create({
        flexColumn: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
        },
        flexRow: {
            display: 'flex',
            flexDirection: 'row',
            // alignItems: 'flex-start',
            justifyContent: 'flex-start',
        },
        flexRowBetween: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        subtitle: {
            fontSize: 16,
            fontWeight: '600',
            fontFamily: FONT_ENUM.MAIN_MEDIUM,
            textAlign: 'left',
            color: theme[colorScheme].tag_white,
        },
        text: {
            fontSize: 16,
            fontWeight: '500',
            fontFamily: FONT_ENUM.MAIN_REGULAR,
            textAlign: 'left',
            color: theme[colorScheme].tag_white,
        },
    });

export { SwitchWithCustomText };
